import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { GetQuotationClientResponse } from '../@types/GetQuotation'

type Store = {
  getQuotation: GetQuotationClientResponse | null
  setGetQuotation: (value: GetQuotationClientResponse) => void
  resetGetQuotation: () => void
}

export const useGetQuotationStore = create<Store>()(
  devtools(
    (set) => ({
      getQuotation: null,
      setGetQuotation: (getQuotation) => set({ getQuotation }),
      resetGetQuotation: () => set({ getQuotation: null }),
    }),
    { name: 'GetQuotationStore' },
  ),
)
